const types = {
  draft: 'draft',
  published: 'published',
}

types.all = Object.keys(types);

export default types;
